<template>
  <div class="rule_page">
    <div class="rule_box">
      <p>1、活动对象：</p>
      <p>国元点金APP用户</p>
      <p>2、活动时间：</p>
      <p>时间为2022年8月15号00:00:00-2022年8月31号23:59:59。</p>
      <p>3、活动玩法</p>
      <p>（1）注册抽盲盒</p>
      <p>
        用户首次有1次免费游戏次数，通过做任务可获得更多游戏次数，任务包括首次登录游戏页、每日首次分享活动、每日浏览指定页面、购买增值服务。用户每天的分享邀请新客户次数上限为20次，购买任一增值服务次日增加5次抽盲盒次数，活动期间每名用户仅享受1回。活动期间每名用户仅享受1回。游戏次数若当天未使用，可累计叠加。（可参与增加次数的增值服务有：云参选股、脱水研报、北上资金票池、AI金股、狙击龙虎榜、机构研选、九点特供、公告全知道）
      </p>
      <p>
        （2）集齐四款小状元需要点击“领取按钮”，领取榜单排名前10名的用户可获得额外奖品的资格。
      </p>
      <p>第1名：110万积分（价值1000元）</p>
      <p>第2名：33万积分（价值300元）</p>
      <p>第3名：11万积分（价值100元）</p>
      <p>第4-10名 55000积分（价值50元）</p>
      <p>（3）抽到隐藏款小状元盲盒（10个）：</p>
      <p>
        可获得积分110万＋任意增值服务体验月卡+体脂秤一台。抽到体脂秤请在活动期间填写正确的寄送地址。
      </p>
      <p>4、关于红包提现：</p>
      <p>
        活动中，用户获得的所有红包均使用提现码提现。（提现码提现规则：用户可复制提现码，打开微信搜索关注“国元证券”微信公众号（gyzqfw-000728），在对话框里发送“818”，即可以收到链接，打开提现页面，输入提现码并验证通过，提现红包将自动发放至用户的微信钱包内，届时用户微信号将收到一条服务通知，请注意查收~
      </p>
      <p>5、重要声明</p>
      <p>
        （1）中奖奖品仅限中奖用户个人领取，如未领取或领取有效期前未及时领取，导致领奖失败。奖励不予补发；
      </p>
        <p>（2）邀请好友的奖励中，红包设置有每日库存兑换上限，当日库存兑换消耗光后即止，先完成先得。</p>
      <p>
        （3）活动期间，如果用户出现违规行为（如刷单、作弊领取、恶意套现等行为）,国元证券有权采取不予发放奖励、冻结已发放的奖励、收回已发放至用户的奖励等处理方式，必要时将追究其法律责任；
      </p>
      <p>（4）当前活动参与较为火爆，可能存在奖品发放延迟，请耐心等待；</p>
      <p>
        （5）如出现不可抗力事件或者情势变更情况（包括但不限于活动受政府机关指令需要停止举办或调整的、活动导致系统故障需要暂停举办）则主办方可依相关规定中止或终止本次活动；
      </p>
      <p>
        （6）在不违反国家相关法律法规的前提下，国元证券有权对本次活动进行合理解释；
      </p>
      <p>（7）如有疑问，可咨询国元证券官方客服热线95578。</p>
    </div>
  </div>
</template>

<script>
import { showToast, pageRecord, setHtmlTitle } from "@/utils/h5";
export default {
  data() {
    return {};
  },
  created() {
    setHtmlTitle("活动规则");
    // this.clientHeight = document.body.clientHeight - 110 - 120;
  },
};
</script>

<style scoped>
</style>
